import React from "react";
import SidebarItem from "./SidebarItem";
import { Link, useLocation } from "react-router-dom";

const sidebar = [
	{ label: "Dashboard", path: "/homepage/dashboard" },
	{ label: "Rules", path: "/homepage/rules" },
	{ label: "Templates", path: "/homepage/templates" },
	{ label: "Block lists", path: "/homepage/block-lists" },
];

export default function Sidebar() {
	const location = useLocation();
	return (
		<aside className="w-44 border-r border-gray-200 bg-white py-6 px-2">
			<ul>
				{sidebar.map((item) => (
					<SidebarItem key={item.label} label={item.label} to={item.path} active={location.pathname === item.path} />
				))}
			</ul>
		</aside>
	);
}
